// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `select.flatpickr-monthDropdown-months {
		background-image: none;
		background: none !important;
	}

	.flatpickr-calendar {
		border: 1px solid #E5E7EB;
		border-radius: 4px;
		box-shadow: -5px 0px 5px rgba(0, 0, 0, 0.2);
	}

	.flatpickr-months{
		font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 19px;
	}
	.flatpickr-current-month {
		font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 19px;
	}

	.flatpickr-current-month .numInputWrapper {
		margin-left: 40px;
	}
	span.flatpickr-weekday {
		font-family: "Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif;
		font-style: normal;
		font-weight: 400;
		font-size: 12px;
		line-height: 14px;
		color: #9CA3AF;
	}
	.flatpickr-calendar.arrowTop:before,
	.flatpickr-calendar.arrowTop:after {
		border-bottom-color: unset;
		border-width: 0;
		margin: 0;
		bottom: unset;
	}
	.flatpickr-time {
		margin: 0;
		background: none;
	}

	span.flatpickr-day.selected {
		background-color: #12A34D;
		border-color: #12A34D;
	}
`, "",{"version":3,"sources":["webpack://./../../packages/plecto-frontend-components/src/components/common/dateTimePicker/flatpickrOverrides.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,2BAA2B;CAC5B;;CAEA;EACC,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;CAC5C;;CAEA;EACC,qEAAqE;EACrE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,qEAAqE;EACrE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;CAClB;;CAEA;EACC,iBAAiB;CAClB;CACA;EACC,qEAAqE;EACrE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;CACf;CACA;;EAEC,0BAA0B;EAC1B,eAAe;EACf,SAAS;EACT,aAAa;CACd;CACA;EACC,SAAS;EACT,gBAAgB;CACjB;;CAEA;EACC,yBAAyB;EACzB,qBAAqB;CACtB","sourcesContent":["select.flatpickr-monthDropdown-months {\n\t\tbackground-image: none;\n\t\tbackground: none !important;\n\t}\n\n\t.flatpickr-calendar {\n\t\tborder: 1px solid #E5E7EB;\n\t\tborder-radius: 4px;\n\t\tbox-shadow: -5px 0px 5px rgba(0, 0, 0, 0.2);\n\t}\n\n\t.flatpickr-months{\n\t\tfont-family: \"Roboto\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 16px;\n\t\tline-height: 19px;\n\t}\n\t.flatpickr-current-month {\n\t\tfont-family: \"Roboto\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 16px;\n\t\tline-height: 19px;\n\t}\n\n\t.flatpickr-current-month .numInputWrapper {\n\t\tmargin-left: 40px;\n\t}\n\tspan.flatpickr-weekday {\n\t\tfont-family: \"Roboto\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tfont-size: 12px;\n\t\tline-height: 14px;\n\t\tcolor: #9CA3AF;\n\t}\n\t.flatpickr-calendar.arrowTop:before,\n\t.flatpickr-calendar.arrowTop:after {\n\t\tborder-bottom-color: unset;\n\t\tborder-width: 0;\n\t\tmargin: 0;\n\t\tbottom: unset;\n\t}\n\t.flatpickr-time {\n\t\tmargin: 0;\n\t\tbackground: none;\n\t}\n\n\tspan.flatpickr-day.selected {\n\t\tbackground-color: #12A34D;\n\t\tborder-color: #12A34D;\n\t}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
